import { render, staticRenderFns } from "./ArrowDollarIcon.vue?vue&type=template&id=4169ed6e&scoped=true"
import script from "./ArrowDollarIcon.vue?vue&type=script&lang=js"
export * from "./ArrowDollarIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4169ed6e",
  null
  
)

export default component.exports